import React from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { SearchSelectBox } from 'jbc-front/components/SearchForm';
import { arrowRenderer } from 'jbc-front/components/Form';

import { getSelectOptions } from 'src/reducers/selectOptions';
import styles from 'src/components/BonusSelectBox.scss';

class BonusSelectBox extends React.Component {
  render() {
    const { bonuses } = this.props;
    return (
      <div className={styles.container}>
        <div className={styles.BonusGroupsWrapper}>
          <Field name="clientBonusId" component={SearchSelectBox} options={bonuses} arrowRenderer={arrowRenderer} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  bonuses: getSelectOptions(state, 'bonuses')
});
export default connect(mapStateToProps)(BonusSelectBox);
